/**
 * 문자열 포맷·검증 유틸
 * v7 HTML의 S 객체를 TypeScript로 포팅
 */

/** HTML 엔티티 이스케이프 — XSS 방지 */
export function escapeHtml(s: string): string {
  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };
  return s.replace(/[&<>"']/g, (c) => map[c] ?? c);
}

/** 숫자만 추출 */
export function digitsOnly(s: string): string {
  return s.replace(/\D/g, '');
}

/** 이메일 형식 검증 */
export function isEmail(s: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
}

/** 사업자등록번호 10자리 검증 */
export function isBusinessNumber(s: string): boolean {
  return /^\d{10}$/.test(digitsOnly(s));
}

/** trim + maxlength 강제 */
export function clean(s: string, max = 200): string {
  return s.trim().slice(0, max);
}

// ================================================================
// 입력 포맷터 — onChange에서 호출
// ================================================================

/**
 * 한국 휴대폰 번호 자동 포맷
 * 예: 01012345678 → 010-1234-5678
 */
export function formatPhone(raw: string): string {
  const d = digitsOnly(raw).slice(0, 11);
  if (d.length < 4) return d;
  if (d.length < 8) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
}

/**
 * 사업자등록번호 자동 포맷
 * 예: 7488801787 → 748-88-01787
 */
export function formatBusinessNumber(raw: string): string {
  const d = digitsOnly(raw).slice(0, 10);
  if (d.length < 4) return d;
  if (d.length < 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5)}`;
}

/**
 * 숫자 천 단위 구분 (표시용)
 * 예: 1234567 → 1,234,567
 */
export function formatNumber(n: number): string {
  return n.toLocaleString('ko-KR');
}

/**
 * 이름 마스킹 (라이브 피드용)
 * 예: 홍길동 → 홍*동, 김철 → 김*, 박지영 → 박*영
 */
export function maskName(name: string): string {
  if (name.length <= 1) return name;
  if (name.length === 2) return `${name[0] ?? ''}*`;
  return `${name[0] ?? ''}*${name.slice(-1)}`;
}
